import { branchConstants } from '../../_constants';
import { branchService } from '../../_services';
import { alertActions, confirmPromptActions, userActions, } from '../index';

export const branchActions = {
    getAllBranches,
    getBranchById,
    createBranch,
    updateBranch,
    deleteBranch,
    activation,
    getActiveBranches,
    getBranchIdFromBase,
};

function branchFetched() { return { type: branchConstants.BRANCH_FETCHED } }
function branchFetching() { return { type: branchConstants.BRANCH_FETCHING } }

function branchSubmitted() { return { type: branchConstants.BRANCH_SUBMITTED } }
function branchSubmitting() { return { type: branchConstants.BRANCH_SUBMITTING } }

function getAllBranches(skip, take, filter, search) {
    return dispatch => {
        dispatch(branchFetching());
        dispatch(userActions.allowLeavePage());
        branchService.getAllBranches(skip, take, filter, search)
            .then(
                branches => {
                    if (branches.length > 0) {
                        dispatch(success(branches));
                        dispatch(branchFetched());
                    } else {
                        dispatch(branchFetched());
                        dispatch(alertActions.warning('No more data to load'))
                    }
                },
                error => {
                    dispatch(branchFetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
    function success(branches) { return { type: branchConstants.GET_BRANCHES, branches } }
}
function getBranchById(code) {
    return dispatch => {
        dispatch(branchFetching());
        dispatch(userActions.allowLeavePage());
        branchService.getBranchById(code)
            .then(
                branch =>{ 
                    dispatch(success(branch))
                    dispatch(branchFetched());
                },
                error => {
                    dispatch(branchFetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );

    };
    function success(branch) { return { type: branchConstants.GET_BRANCH_BY_ID, branch } }
}
function createBranch(payload) {
    return dispatch => {
        dispatch(branchSubmitting());
        dispatch(userActions.notallowLeavePage());
        branchService.createBranch(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(alertActions.success('Branch added successfully'))
                    window.location.href = '/master_data/branches';
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(branchSubmitted());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}
function updateBranch(payload, id) {
    return dispatch => {
        dispatch(branchSubmitting());
        dispatch(userActions.notallowLeavePage());
        branchService.updateBranch(payload, id)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(alertActions.success('Branch updated successfully'))
                    window.location.href = '/master_data/branches';
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(branchSubmitted());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}
function deleteBranch(type, id, take) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        branchService.deleteBranch(id)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.success('Branch deleted successfully'));
                    switch (type) {
                        case "specific":
                            window.location.href = '/master_data/branches';
                            break;
                        default:
                            dispatch(getAllBranches(0, take));
                            break;
                    }
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.error(error.toString()))
                    switch (type) {
                        case "specific":
                            window.location.href = '/master_data/branches';
                            break;
                        default:
                            dispatch(getAllBranches(0, take));
                            break;
                    }
                }
            );
    };
}
function activation(id, isActive) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        branchService.activation(id, isActive)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(getBranchById(id));
                    dispatch(alertActions.success(isActive ? 'Branch activated successfully' : 'Branch deactivated successfully'))
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(getBranchById(id));
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
}
function getActiveBranches() {
    return dispatch => {
        branchService.getActiveBranches()
            .then(
                activeBranches => {
                    dispatch(success(activeBranches));
                },
                error => {
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(activeBranches) { return { type: branchConstants.GET_ACTIVE_BRANCHES, activeBranches } }
}
function getBranchIdFromBase(payload) {
    return dispatch => {
        dispatch(branchFetching());
        branchService.getBranchIdFromBase(payload)
            .then(
                branchFromBASE => {
                    dispatch(success(branchFromBASE))
                    dispatch(branchFetched());
                },
                error => {
                    dispatch(branchFetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );

    };
    function success(branchFromBASE) { return { type: branchConstants.GET_BRANCH_FROM_BASE, branchFromBASE } }
}